<template>
    <div>
        <div class="white-box white-box-no-tab text-base xs:text-lg pb-10">
            <Title
                styleCodePage
                :text="`${$route.meta.pageTitle}(${applyWay?.name||''})`"
            />

            <h4 class="py-3 md:pb-3.5 md:pt-0">
                請選擇欲授權銀行
            </h4>
            <div class="pb-3.5">
                <h5 v-if="continueStatus==='Y'">
                    {{ `${userInfo.shortBankCode}  ${userInfo.bankName}` }}
                </h5>
                <Multiselect
                    v-else
                    v-model="userInfo.bankCode"
                    :options="bankList"
                    class="select-base max-w-[20rem] ml-0"
                    placeholder="請選擇"
                    label="label"
                    :can-clear="false"
                    :can-deselect="false"
                    searchable
                    no-options-text="查無銀行資料"
                    no-results-text="查無銀行資料"
                    @select="getPolicy({ clearPolicy: true, resetApplyStaffDiscount: true })"
                />
            </div>
            <!-- <transition name="expand"> -->
            <div
                v-if="userInfo.bankCode"
                class="pb-3.5 border-t bnorder-gray-200"
            >
                <Nodata
                    v-if="policyList.length === 0 && !isLoading"
                    class="mt-5"
                >
                    無保單資料
                </Nodata>
                <template v-else>
                    <h4 class="pt-3 pb-0 md:pt-5">
                        請選擇欲申請之保單
                        <span class="text-sm xs:text-base text-error">
                            (每次申請僅能授權一張保單)
                        </span>
                    </h4>
                    <!-- 富邦專用 -->
                    <h5
                        v-if="continueStatus==='Y' && userInfo.bankCode===fubonBank && applyWay?.type===typeListACH[0].type"
                        class="mt-1.5 mb-2.5"
                    >
                        {{ userInfo.currency==='NTD'?'台幣保單':'外幣保單' }}
                    </h5>
                    <div
                        v-else-if="userInfo.bankCode===fubonBank && applyWay?.type===typeListACH[0].type"
                        class="flex my-2.5"
                    >
                        <Radio
                            v-model:checkedValue="userInfo.currency"
                            value="NTD"
                            name="policyDollor"
                            text="台幣保單"
                            @change="makePolicyList({ clearPolicy: true, resetApplyStaffDiscount: true })"
                        />
                        <Radio
                            v-model:checkedValue="userInfo.currency"
                            value="FRD"
                            name="policyDollor"
                            text="外幣保單"
                            class="ml-6"
                            @change="makePolicyList({ clearPolicy: true, resetApplyStaffDiscount: true })"
                        />
                    </div>
                    <ul
                        v-else
                        class="text-tip text-sm mb-2.5"
                    >
                        <li>僅提供台幣保單申請</li>
                    </ul>

                    <transition name="expand">
                        <div v-if="userInfo.currency==='NTD' && userInfo.hasStaffDiscount">
                            <h4 class="pt-3 pb-0 md:pt-1">
                                是否申請集團員工優惠
                            </h4>
                            <h5
                                v-if="continueStatus"
                                class="mt-1.5 mb-2.5"
                            >
                                {{ userInfo.applyStaffDiscount==='Y'?'申請':'不申請' }}
                            </h5>
                            <div
                                v-else
                                class="flex my-2.5"
                            >
                                <Radio
                                    v-model:checkedValue="userInfo.applyStaffDiscount"
                                    value="Y"
                                    name="applyStaffDiscount"
                                    text="申請"
                                    @change="makePolicyList({ clearPolicy: true, resetApplyStaffDiscount: false })"
                                />
                                <Radio
                                    v-model:checkedValue="userInfo.applyStaffDiscount"
                                    value="N"
                                    name="applyStaffDiscount"
                                    text="不申請"
                                    class="ml-6"
                                    @change="makePolicyList({ clearPolicy: true, resetApplyStaffDiscount:false })"
                                />
                            </div>
                        </div>
                    </transition>
                    <Nodata
                        v-if="applyPolicyList.length === 0 && !isLoading"
                        class="mt-5"
                    >
                        查無可申請之保單
                    </Nodata>
                    <template v-else>
                        <PolicyCard
                            v-model:checkedRadio="userInfo.policyNo"
                            :data="applyPolicyList"
                            class="lg:hidden"
                        />
                        <!-- for computer -->
                        <PolicyTable
                            v-model:checkedRadio="userInfo.policyNo"
                            :data="applyPolicyList"
                            class="hidden lg:block"
                        />
                    </template>
                </template>
                <template v-if="disablePolicyList.length > 0">
                    <h5 class="pb-3 pt-8">
                        無法辦理之保單
                    </h5>
                    <PolicyCard
                        :data="disablePolicyList"
                        disabled
                        class="lg:hidden"
                    />
                    <!-- for computer -->
                    <PolicyTable
                        :data="disablePolicyList"
                        disabled
                        class="hidden lg:block"
                    />
                </template>
                <!-- <template v-if="disablePolicyList.length === 0">
                        <Nodata>無保單資料</Nodata>
                    </template> -->
            </div>
            <!-- </transition> -->
        </div>

        <Bottombar :control-visible="!!userInfo.policyNo">
            <template #right>
                <button
                    class="btn btn-accent rounded-full"
                    :disabled="!userInfo.policyNo || isLoading"
                    @click="goNext()"
                >
                    下一步
                </button>
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import Title from '@/components/text/Title.vue';
import Multiselect from '@vueform/multiselect';
import Bottombar from '@/components/layout/Bottombar.vue';
import Loading from '@/components/Loading.vue';
import Nodata from '@/components/text/EmptyData.vue';
import routeName from '@/router/constant.js';
import PolicyCard from './PolicyCard.vue';
import PolicyTable from './PolicyTable.vue';
import Radio from '@/components/radios/Radio.vue';
import { getBankListACH, postPolicyACH, submitPolicyACH, getContinueInfoACH, submitTypeACH } from '@/apis/aplCatlACH.js';
import { startTransaction } from '@/apis/system';
import codeList from '@/json/codeList.js';
import _ from 'lodash';
import dialogContent from '@/json/dialogContent';
import typeListACH from '@/json/typeListACH';

export default {
    components: {
        Title,
        Radio,
        Multiselect,
        PolicyCard,
        Bottombar,
        Loading,
        Nodata,
        PolicyTable,
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const isDisableButton = ref(false);
        const isLoading = ref(false);
        const hasDiscount = ref(false);
        const fubonBank = '0120000';
        const bankList = ref(null);
        const code = codeList.ACH;
        const policyList = ref([]);
        const applyPolicyList = ref([]);
        const disablePolicyList = ref([]);
        const resultUserInfo = computed(() => store.state.services.changeItemsResult[code]);
        const continueStatus = computed(() => store.state.services.changeItemsResult[`${code}continue`]);

        const applyWay = computed(() => store.state.services.changeItemsResult[`${code}applyWay`]);

        const userInfo = ref({
            id: '',
            bankCode: '',
            bankName: '',
            shortBankCode: '',
            bankAccount: '',
            policyNo: '',
            // 保單幣別分類
            currency: 'NTD',
            // 可否選擇員工優惠，true顯示radio
            hasStaffDiscount: false,
            // 是否申請員工優惠
            applyStaffDiscount: '',
            name: '',
            mobile: '',
            radiodata: '',
        });
        // 取得接續資料，並更新至userInfo
        const getContinueInfo = () => {
            getContinueInfoACH().then(res => {
                // 後端回傳的applyStaffDiscount是Boolean
                const { bankCode, applyStaffDiscount, bankAccount, foreignCurrency, type } = res.data;
                userInfo.value.bankCode = bankCode;
                userInfo.value.applyStaffDiscount = applyStaffDiscount ? 'Y' : 'N';
                userInfo.value.bankAccount = bankAccount;
                userInfo.value.currency = foreignCurrency ? 'FRD' : 'NTD';
                userInfo.value.type = type;

                getPolicy({ clearPolicy: true, resetApplyStaffDiscount: false });
                store.dispatch('services/setChangeItemsResult', { code: `${code}continue`, value: 'Y' });
            }).catch(() => {
                modalShow(dialogContent.reApply);
            });
        };
        // 取得可驗證銀行列表
        const getBankList = () => {
            return getBankListACH(applyWay.value.type).then(res => {
                const list = res.data?.achBankList.map(i => {
                    i.value = i.bankCode;
                    i.label = `${i.shortBankCode} ${i.bankName}`;
                    return i;
                });

                return list;
            }).catch(() => {
                return [];
            });
        };

        // 通知後端交易開始
        const startService = () => {
            return startTransaction().then(() => {
                return true;
            }).catch(() => {
                return false;
            });
        };
        // 首次變更要提交類型
        const submitType = () => {
            return submitTypeACH(applyWay.value.type).then(() => {
                return true;
            }).catch(() => {
                return false;
            });
        };
        // 一進入畫面
        const start = async () => {
            isLoading.value = true;
            bankList.value = await getBankList();
            if (await startService()) {
                if (continueStatus.value === 'getData') {
                    getContinueInfo();
                } else {
                    await submitType();
                }
            }
            isLoading.value = false;
        };

        // 繼續 打api 更新UserInfo >> 返回 用UserInfo
        // new送出之後更新UserInfo >> 返回 用UserInfo
        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                        router.push({ name: routeName.HOME });
                    },
                },
            });
        };
        const edit = async () => {
            bankList.value = await getBankList();
            userInfo.value = _.cloneDeep(resultUserInfo.value);
            getPolicy({ clearPolicy: false, resetApplyStaffDiscount: false });
        };
        if ((!continueStatus.value && !resultUserInfo.value) || (continueStatus.value === 'getData')) {
            start();
        } else if ((!continueStatus.value && resultUserInfo.value) || (continueStatus.value === 'Y')) {
            edit();
        } else {
            modalShow(dialogContent.reApply);
        }

        const memoList = (disabled, item) => {
            const list = [];
            item.description && list.push(item.description);
            const apply = userInfo.value.applyStaffDiscount;
            // C.選【申請】，依F、A系統檢核檔判斷不得中途加入，於無法辦理之保單的備註顯示「此保單不得中途加入富邦集團員工優惠」
            // B.選【申請】，如保單主約險種不可享有集團員工優惠，於無法辦理之保單的備註顯示「此保單無富邦集團員工優惠」
            // BC 正常顯示
            const consideration = (apply === 'Y') ||
                // 申請不申請都可以的保單
                (apply === '') ||
                // 選擇【不申請】的可選擇區塊不影響
                (hasDiscount.value && apply === 'N' && !disabled) ||
                // D.選【不申請】，無法辦理之保單的備註不顯示「此保單無富邦集團員工優惠」、「此保單不得中途加入富邦集團員工優惠」。
                (hasDiscount.value && apply === 'N' && disabled && item.staffDescriptionType !== '02' && item.staffDescriptionType !== '04') ||
                // E.保單全部都不享有集團員工優惠或要保人非集團員工，無法辦理之保單的備註不顯示「此保單無富邦集團員工優惠」、「此保單不得中途加入富邦集團員工優惠」。
                (!hasDiscount.value && disabled && item.staffDescriptionType !== '02' && item.staffDescriptionType !== '04');
            if (consideration) {
                item.staffDescription && list.push(item.staffDescription);
            }
            return list;
        };

        const makePolicyList = ({ clearPolicy = true, resetApplyStaffDiscount = true }) => {
            if (clearPolicy) {
                userInfo.value.policyNo = '';
            }
            if (userInfo.value.currency !== 'NTD') {
                // 選擇外幣，無集團優惠
                hasDiscount.value = false;
                userInfo.value.applyStaffDiscount = 'N';
            } else if (resetApplyStaffDiscount) {
                hasDiscount.value = !!policyList.value.find(i => i.staff);
                userInfo.value.applyStaffDiscount = hasDiscount.value ? 'Y' : '';
            }
            const { applyStaffDiscount, currency } = userInfo.value;
            disablePolicyList.value = [];
            applyPolicyList.value = [];
            const isNTD = currency === 'NTD';
            policyList.value.forEach(i => {
                const consideration = i.currency === 'NTD';
                // 先判斷幣別
                if (consideration === isNTD) {
                    const canSelect = i.staffDiscount === applyStaffDiscount || i.staffDiscount === '';
                    // disabled區塊
                    if (!canSelect || i.disable) {
                        i.memoList = memoList(true, i);
                        disablePolicyList.value.push(i);
                    } else {
                        // selected區塊
                        if (canSelect) {
                            i.memoList = memoList(false, i);
                            applyPolicyList.value.push(i);
                        }
                    }
                }
            });
        };

        const getPolicy = ({ clearPolicy = true, resetApplyStaffDiscount = true }) => {
            isLoading.value = true;
            postPolicyACH(userInfo.value.bankCode).then(res => {
                const { achPolicyOverviewList, id, name } = res.data;
                policyList.value = achPolicyOverviewList.map(i => {
                    i.policyNoSeqSrceFromIdDup = `${i.policyNo},${i.policySeq},${i.srceFrom},${i.idDup},${i.mobile}`;
                    return i;
                }) || [];

                const bankData = bankList.value.find(i => i.bankCode === userInfo.value.bankCode);
                // 有無員工優惠
                // 如果有員工優惠區塊 預設申請
                hasDiscount.value = !!policyList.value.find(i => i.staff);

                userInfo.value = {
                    ...userInfo.value,
                    id,
                    name,
                    hasStaffDiscount: hasDiscount.value,
                    bankName: bankData.bankName,
                    shortBankCode: bankData.shortBankCode,
                };

                if (!continueStatus.value && !resultUserInfo.value) {
                    userInfo.value = {
                        ...userInfo.value,
                        // 預設申請，沒有的話預設''
                        applyStaffDiscount: hasDiscount.value ? 'Y' : '',
                        currency: 'NTD',
                        policyNo: ''
                    };
                }
                if (continueStatus.value && route.params.from === routeName.FINISH) {
                    store.dispatch('services/setChangeItemsResult', { code, value: userInfo });
                }
                makePolicyList({ clearPolicy, resetApplyStaffDiscount });
                isLoading.value = false;
            }).catch(() => { isLoading.value = false; });
        };
        const goNext = () => {
            isLoading.value = true;
            const radiodata = userInfo.value.policyNo.split(',');
            const obj = {
                bankCode: userInfo.value.bankCode,
                applyStaffDiscount: userInfo.value.applyStaffDiscount === 'Y',
                policyNo: radiodata[0],
                policySeq: radiodata[1],
                idDup: radiodata[3],
                srceFrom: radiodata[2],
            };

            submitPolicyACH(obj).then(() => {
                store.dispatch('services/setChangeItemsResult', {
                    code,
                    value: {
                        ...userInfo.value,
                        mobile: radiodata[4],
                        radiodata,
                    }
                });
                continueStatus.value ? router.push({ name: routeName.CONFIRM_DATA }) : router.push({ name: routeName.AUTH_TERMS });
                isLoading.value = false;
            }).catch(() => {
                isLoading.value = false;
            });
        };
        return {
            hasDiscount,
            isDisableButton,
            isLoading,
            bankList,
            userInfo,
            policyList,
            disablePolicyList,
            applyPolicyList,
            getPolicy,
            goNext,
            makePolicyList,
            applyWay,
            typeListACH,
            fubonBank,
            continueStatus
        };
    },
};
</script>
<style lang="scss" scoped>
.expand-leave-active,
.expand-enter-active {
    transition: max-height 0.2s linear;
}
.expand-enter-from,
.expand-leave-to {
    max-height: 0;
    overflow: hidden;
}

.expand-enter-to,
.expand-leave-from {
    max-height: 200px;
    overflow: hidden;
}
</style>
